<template>
  <div class="mixedmode-period">
    <p class="description">
      {{$tI_G('Migration period slider CTA')}}
    </p>
    <div class="lab-timeline">
      <div class="line-item" 
        v-for="periodItem in periods" :key="periodItem.id"
        :class="{'done': periodItem.number <= selectedPeriodNumber,
                'active': periodItem.id == selectedPeriodId}" >
          <div class="node">
            <span class="timeline-title sub-title">{{ $tI(periodItem.name)}}</span>
            <div class="tvar" @click="onChangePeriod(periodItem)"></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import MixedModeDataWatcher from '../services/MixedModeDataWatcher'
export default {
  components: {
  },
  props: {
    wayType: {
      type: String,
      required: true,
    },
  },
  methods: {
    onChangePeriod(periodItem) {
      if (this.wayType === 'TWO') {
        this.$store.commit('mixedModePeriod/setSelectedTwoPeriod', periodItem);
      } else {
        this.$store.commit('mixedModePeriod/setSelectedThreePeriod', periodItem);
      }

      let value = '';
      if (periodItem.number === 1) {
        value = 'Iframe.ancientDnaGeneticSimilaritiesBronzeAgeClicked'
      } else if(periodItem.number === 2) {
        value = 'Iframe.ancientDnaGeneticSimilaritiesIronAgeClicked'
      } else if(periodItem.number === 3) {
         value = 'Iframe.ancientDnaGeneticSimilaritiesRomanEraClicked'
      } else if(periodItem.number === 4) {
         value = 'Iframe.ancientDnaGeneticSimilaritiesMiddleAgesClicked'
      }
      
      communicationService.sendDataToParent({
        key: dataKeys.STATISTICS,
        value: value,
      });
    },
  },
  computed: {
    selectedPeriodId() {
      return this.wayType === 'TWO' ? this.$store.state.mixedModePeriod.selectedTwoWayPeriod.id :
            this.$store.state.mixedModePeriod.selectedThreeWayPeriod.id;
    },
    selectedPeriodNumber() {
      return this.wayType === 'TWO' ? this.$store.state.mixedModePeriod.selectedTwoWayPeriod.number :
            this.$store.state.mixedModePeriod.selectedThreeWayPeriod.number;
    },
    periods() {
      return this.$store.getters['mixedModePeriod/getPeriods'];
    },
  },
  mounted() {
    this.$store.dispatch('mixedModePeriod/fetchPeriods');
    MixedModeDataWatcher.init();
  },
  beforeDestroy() {
    MixedModeDataWatcher.cleanup();
  },
}
</script>

<style lang="scss" scoped>
.mixedmode-period {
  padding: 1rem;
  height: 100%;
  background-color: var(--white-100);

  @media screen and (max-width: 769px) {
    height: auto;
  }
}
</style>
